import React from 'react';
import { BookingsByDestinationChart } from './charts/BookingsByDestinationChart';
import { ErrorBar, LoadingBar } from 'ui/NetworkStatusBar';
import { IDestinationBreakdownResponse } from 'services/DashboardApi/types';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';

interface IBookingsByDestinationDataProps {
  bookingsByDestinationData?: IDestinationBreakdownResponse;
  isLoadingBookingsByDestinationData: boolean;
  isErrorBookingsByDestinationData: boolean;
}

export const BookingsByDestinationData: React.FC<IBookingsByDestinationDataProps> = ({ bookingsByDestinationData, isLoadingBookingsByDestinationData, isErrorBookingsByDestinationData }) => {
  const { isMobile } = useResponsive();

  if (isErrorBookingsByDestinationData) {
    return (
      <div className="w-full flex justify-center items-center mt-[100px] mb-[25px] px-[10px]">
        <ErrorBar />
      </div>
    );
  }
  
  if (isLoadingBookingsByDestinationData || !bookingsByDestinationData) {
    return (
      <div className="w-full flex justify-center items-center mt-5 mb-5">
        <LoadingBar label="Loading" />
      </div>
    );
  }

  return (
    <div className={isMobile ? 'm-0' : 'mt-[20px] mb-[20px]'}>
      <BookingsByDestinationChart bookingsByDestinationData={bookingsByDestinationData} />
    </div>
  );
};
